<template>
	<div class="perfil">
		<div class="perfil-header">
			<div class="container">
				<span class="cuenta-subtitle">Hola</span>
				<h1>{{ this.$store.state.usuarioNombre }}</h1>
			</div>
		</div>
		<div class="horizontal-menu">
			<router-link :to="{ name: 'mi-cuenta' }" class="menu-item active">
				<span>Mi cuenta</span>
			</router-link>
			<router-link :to="{ name: 'mis-amigos' }" class="menu-item">
				<span>Mis amigos</span>
			</router-link>
			<router-link :to="{ name: 'mis-entradas' }" class="menu-item">
				<span>Mis entradas</span>
			</router-link>
			<a href="#" @click="cerrarSesion" class="menu-item">
				<span>Cerrar sesión</span>
			</a>
		</div>
		<div class="perfil-container">
			<router-view name="cuenta" class="container"></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			cerrarSesion(){
				this.$store.dispatch('destroyToken')
				.then(response => {
					this.$router.push({ name: 'home' })
					location.reload();
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.perfil{
		min-height: calc(100vh - var(--height-top-header) - var(--height-footer));
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);
		// background: var(--color-grey-lighter);

		.perfil-header{
			width: 100%;
			min-height: 320px;
			max-height: 60vh;
			background-image: url('../../assets/jmd.jpg');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			@include flex(row, center, flex-end);
			position: relative;
			padding-top: 72px;

			&:after{
				content: "";
				width: 100%;
				height: 100%;
				z-index: 0;
				background-color: var(--color-black);
				opacity: 0.55;
				position: absolute;
				top: 0;
				left: 0;
			}

			&:before{
				content: "";
				width: 100%;
				height: 120px;
				background: linear-gradient(180deg,rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
				position: absolute;
				top: 0;
				left: 0;
			}

			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				// padding: 0;
				z-index: 1;
				padding-bottom: 40px;
				@include flex(column, flex-end, flex-start);

				h1{
					margin: 0;
					color: var(--color-white);
					font-family: var(--font-family-kapra-bold);
					text-transform: uppercase;
					font-size: 100px;
					-webkit-letter-spacing: -1px;
					-moz-letter-spacing: -1px;
					-ms-letter-spacing: -1px;
					letter-spacing: -1px;
					line-height: 70px;
					width: 100%;
				}

				span.cuenta-subtitle{
					display: block;
					color: var(--color-blue-light);
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					text-transform: uppercase;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					font-size: 20px;
					line-height: 30px;
					margin-bottom: -12px;
				}
			}
		}

		.perfil-container{
			width: 100%;
			position: relative;
			margin: 64px 0 80px;
			@include flex(row, space-between, flex-start);

			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
			}
		}
	}

	@media screen and(max-width: 1120px){
		.perfil{
			.perfil-container{
				margin: 20px 0 30px;
			}
		}
	}

	@media screen and(max-width: 820px){
		.perfil{
			.perfil-header{
				padding-top: 56px;
				min-height: 250px;
				.container{
					h1{
						font-size: 70px;
						line-height: 54px;
					}
				}
			}
		}
	}

	@media screen and(max-width: 480px){
		.perfil{
			.perfil-header{
				min-height: 220px;
				.container{
					span.cuenta-subtitle{
						font-size: 16px;
						line-height: 30px;
					}
					h1{
						font-size: 40px;
						line-height: 36px;
					}
				}
			}
		}
	}
</style>